module.exports = __webpack_public_path__ + "img/ps-32.8a25a159.jpg";